import React from 'react';
import { Divider, Paper, Stack, Typography } from '@mui/material';
import { AdminTabs } from '../AdminDetailsTabs';
import { Outlet } from 'react-router-dom';

export const AdminOverviewPage = () => {
  return (
    <Paper sx={{ p: 5 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={10}>
        <Typography variant="h2">Admin Page</Typography>
      </Stack>
      <AdminTabs />
      <Divider sx={{ mb: 10 }} />
      <Outlet />
    </Paper>
  );
};
